module.exports = __webpack_public_path__ + "img/close.ca8bc72e.svg";